import { responseType } from '@pascal/pascal-core';

const AdditionalResponseCode = {
  InValidMinBet: 2,
  2: 'InValidMinBet',
  InValidMaxBet: 3,
  3: 'InValidMaxBet',
  InValidAutoCashOutOdd: 1000,
  1000: 'InValidAutoCashOutOdd',
  1008: 'InValidMaxAutoCashOutOdd',
  InValidMaxAutoCashOutOdd: 1008,
};

const AdditionalResponseType = {
  ...responseType,
  InValidMinBet: 'InValidMinBet',
  InValidMaxBet: 'InValidMaxBet',
  InValidAutoCashOutOdd: 'InValidAutoCashOutOdd',
  InValidMaxAutoCashOutOdd: 'InValidMaxAutoCashOutOdd',
};

const GameResponseTypeName = {
  Bet: {
    InValidMin: AdditionalResponseType.InValidMinBet,
    InValidMax: AdditionalResponseType.InValidMaxBet,
  },
  AutoCashOut: {
    InValidMin: AdditionalResponseType.InValidAutoCashOutOdd,
    InValidMax: AdditionalResponseType.InValidMaxAutoCashOutOdd,
  },
};

Object.freeze(GameResponseTypeName);

export { AdditionalResponseCode, AdditionalResponseType, GameResponseTypeName };
